import React, { useState, useEffect, useRef } from "react";

const AnimatedCounter: React.FC<{ to: number; duration: number; delimiter?: string }> = ({ to, duration, delimiter = "," }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTimestamp: number | null = null;
    let animationFrame: number;

    const easeOutQuad = (t: number) => t * (2 - t);

    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const easedProgress = easeOutQuad(progress);
      setCount(Math.floor(easedProgress * to));
      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(step);
      }
    };
    animationFrame = window.requestAnimationFrame(step);

    return () => window.cancelAnimationFrame(animationFrame);
  }, [to, duration]);

  return (
    <span className="elementor-counter-number">
      {delimiter ? count.toLocaleString() : count.toString()}
    </span>
  );
};


const Banner: React.FC = () => {
  return (
    <section
      id="banner"
      className="elementor-section elementor-top-section elementor-element elementor-element-1f8a680 elementor-section-full_width elementor-section-height-min-height elementor-section-items-stretch elementor-section-content-bottom scheme_default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
      data-id="1f8a680" data-element_type="section"
      data-settings='{"background_background":"classic"}'>
      <div className="elementor-container elementor-column-gap-extended">
        <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7362a5e sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
          data-id="7362a5e" data-element_type="column">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-8770aef sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="8770aef" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div data-animation-type="block"
              className="elementor-element elementor-element-0b7b0b4 animation_type_block sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited animated printo-fadeinleft"
              data-id="0b7b0b4" data-element_type="widget"
              data-settings='{"_animation":"printo-fadeinleft"}'
              data-widget_type="trx_sc_title.default">
              <div className="elementor-widget-container">
                <div className="sc_title sc_title_default">
                  <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                    <span className="sc_item_title_text">Where Imagination Takes Shape</span>
                  </h1>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-3db7f0d sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="3db7f0d" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div data-animation-type="block"
              className="elementor-element elementor-element-33e07bf animation_type_block sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited animated printo-fadeinleft"
              data-id="33e07bf" data-element_type="widget"
              data-settings='{"_animation":"printo-fadeinleft"}'
              data-widget_type="text-editor.default">
              <div className="elementor-widget-container">
                Secondary statements - Empowering businesses and creators
                with high-quality, affordable 3D printing solutions.
                Fast, reliable, and designed to scale with your vision
              </div>
            </div>
            <div className="elementor-element elementor-element-f9fae34 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="f9fae34" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div data-animation-type="block"
              className="elementor-element elementor-element-8dcefaa animation_type_block sc_fly_static elementor-widget elementor-widget-trx_sc_button trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited animated printo-fadeinleft"
              data-id="8dcefaa" data-element_type="widget"
              data-settings='{"_animation":"printo-fadeinleft"}'
              data-widget_type="trx_sc_button.default">
              <div className="elementor-widget-container">
                <div className="sc_item_button sc_button_wrap">
                  <a href="#go-anchor"
                    className="sc_button sc_button_default sc_button_size_normal sc_button_icon_left">
                    <span className="sc_button_text">
                      <span className="sc_button_title">Learn More</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-8f89a0e sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="8f89a0e" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-counter-row sc_fly_static elementor-widget elementor-widget-counter" style={{ display: 'flex', justifyContent: 'flex-start', gap: '60px', marginTop: '40px', flexWrap: 'wrap' }}>
              <div className="elementor-counter" style={{ textAlign: 'left' }}>
                <div className="elementor-counter-number-wrapper" style={{ fontSize: '48px', fontWeight: '700', lineHeight: '1', color: '#1a1a1a', display: 'flex', alignItems: 'center' }}>
                  {/* <AnimatedCounter to={1000} duration={2000} /> */}
                  <span className="elementor-counter-number-suffix" style={{ marginLeft: '10px' }}></span>
                </div>
                <div className="elementor-counter-title" style={{ fontSize: '18px', marginTop: '12px', color: '#1a1a1a', fontWeight: '500' }}></div>
              </div>

              <div className="elementor-counter" style={{ textAlign: 'left' }}>
                <div className="elementor-counter-number-wrapper" style={{ fontSize: '48px', fontWeight: '700', lineHeight: '1', color: '#1a1a1a', display: 'flex', alignItems: 'center' }}>
                  {/* <AnimatedCounter to={10000} duration={2000} /> */}
                  <span className="elementor-counter-number-suffix" style={{ marginLeft: '10px' }}></span>
                </div>
                <div className="elementor-counter-title" style={{ fontSize: '18px', marginTop: '12px', color: '#1a1a1a', fontWeight: '500' }}></div>
              </div>

              <div className="elementor-counter" style={{ textAlign: 'left' }}>
                <div className="elementor-counter-number-wrapper" style={{ fontSize: '48px', fontWeight: '700', lineHeight: '1', color: '#1a1a1a', display: 'flex', alignItems: 'center' }}>
                  {/* <AnimatedCounter to={75} duration={2000} /> */}
                  <span className="elementor-counter-number-suffix" style={{ marginLeft: '10px' }}></span>
                </div>
                <div className="elementor-counter-title" style={{ fontSize: '18px', marginTop: '12px', color: '#1a1a1a', fontWeight: '500' }}></div>
              </div>
            </div> 
            <div className="elementor-element elementor-element-2109fe5 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="2109fe5" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-38a58e2 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
          data-id="38a58e2" data-element_type="column"
          data-settings='{"background_background":"classic"}'>
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-dab2a9e sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="dab2a9e" data-element_type="widget"
              data-widget_type="spacer.default">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
